export default "__VITE_ASSET__ChZQegFt__"